import FormAutoEditor from '.';
import FormAutoEditorDesignTool from "./DesignTool";
import { getFormAutoEditorConversions } from './convertUtils';
import UiSettingsEditorMeta from './UiSettingsEditor.meta';

/** @type {UICore.ComponentMeta} */
const FormAutoEditorComponentMeta = {
  id: 'w-form-auto-editor',
  name: '表单生成器',
  keywords: ['动态编辑控件', '推导'],
  isFormContainer: true,
  category: '表单',
  icon: 'https://vfiles.gtimg.cn/wuji_dashboard/xy/rainbow/icon-auto-editor_1636361982252.png',
  component: FormAutoEditor,
  bindings: [{
    id: '数据源',
    required: true,
    main: true,
    pathProp: 'path'
  }, {
    id: '数据Schema',
    checkData: s => s.type === 'object',
    prop: 'dataSchema'
  }],
  propsSchema: {
    type: 'object',
    fields: [{
      id: 'path',
      type: 'string',
      title: '数据字段'
    }, {
      id: 'schemaType',
      type: 'string',
      title: '表单项规则',
      default: 'default',
      enum: [{
        value: 'auto',
        label: '自动推导'
      }, {
        value: 'schemaRule',
        label: '自定义规则'
      }, {
        value: 'default',
        label: '自定义schema'
      }]
    }, {
      id: 'dataSchema',
      type: 'any',
      title: '数据 Schema (若不了解，请保持默认值 null)',
      description: '若不了解用途，请保持默认值 null\n\n格式为 DataSchema',
      default: null,
      condition: 'props.schemaType==="default"'
    }, {
      id: 'schemaRule',
      type: 'string',
      title: '推导规则',
      description: '可以根据数据特征提供特定的组件',
      default: `({data, schema}) => {
  // schema : {id:string, title:string, type:string}
  // 在这里可以根据data或者schema来决定是否要修改当前字段的组件推导
  if (schema.id === 'type') {
    // 选择1 可以修改推导的schema类型 "boolean" | "object" | "array" | "number" | "string" | "integer" | "any"
    return 'boolean';
    // 选择2 可以指定一个组件Id
    return {
      type: 'numberInput',
      props: {
        required: true
      }
    };
  }
}`,
      condition: 'props.schemaType==="schemaRule"',
      ui: {
        type: 'exprInput',
        props: {
          multipleLine: true,
          notifyVoidReturn: true
        }
      }
    }, {
      id: 'required',
      type: 'boolean',
      title: '必填'
    }, {
      id: 'readonly',
      type: 'boolean',
      title: '只读'
    }, {
      id: 'disabled',
      type: 'boolean',
      title: '禁用'
    }, {
      id: 'flatten',
      type: 'boolean',
      title: '平铺字段',
      default: true
    }, {
      id: 'cardInForm',
      type: 'boolean',
      title: '卡片包围',
      description: '表单和表单项之间插入卡片组件',
      default: true
    }, {
      id: 'proxySchema',
      type: 'boolean',
      title: '代理schema',
      description: '内部组件获得的schema变为该组件输入的schema',
      default: false,
      group: '高级'
    }, {
      id: 'uiSettings',
      type: 'any',
      ui: {
        type: '__uiSettingsEditor'
      },
      default: {}
    }]
  },
  initialLayout: {
    props: {
      schemaType: 'schemaRule',
      proxySchema: true
    }
  },
  fitData: () => null,
  propPanel: {
    __uiSettingsEditor: UiSettingsEditorMeta
  },
  designTool: FormAutoEditorDesignTool,
  getActions: getFormAutoEditorConversions
};
export default FormAutoEditorComponentMeta;
//# sourceMappingURL=meta.js.map
